import * as preact from 'preact'
const { h, Component } = preact
import classNames from 'classnames'
import * as styles from './style.css'
import { Image } from './image'
import { Video } from './video'
import { Black } from './black'
import { Section } from '../types'
import { PhotoCredit } from './photocredit'
import PureComponent from '../../lib/preact-pure-component'
import { connect } from '../../../lib/provider'
import { isIe } from '../../lib/isIe'
import { testReducedMotion } from '@nrk/feature-tests'
interface Props {
  section: Section
  active: boolean
  preload: boolean
  fadeUpDelay: boolean
}

interface ConnectedProps {
  sendGaEvent: (evt: Object) => void
}

function getComponentForType(type: string) {
  switch (type) {
    case 'image':
      return Image
    case 'video':
      return Video
    case 'black':
    default:
      return Black
  }
}

class _Background extends PureComponent<ConnectedProps & Props, {}> {
  componentDidUpdate(prevProps: Props) {
    if (!prevProps.active && this.props.active) {
      this.props.sendGaEvent({ action: 'readChapter', label: this.props.section.id })
    }
  }

  render() {
    const shouldRender = this.props.active || this.props.preload
    if (!shouldRender) {
      return null
    }
    const { style, type, props } = this.props.section
    const Component = getComponentForType(type)
    const photographer = props && props.photographer ? props.photographer : undefined
    const shouldZoom =
      style && style.indexOf('zoomIn') > -1 && typeof window !== 'undefined' && !isIe() && !testReducedMotion()
    const wrapperClasses = classNames(styles.background, {
      [styles.zoomIn]: shouldZoom
    })
    const fadeClasses = classNames(styles.backgroundElement, {
      [styles.active]: this.props.active,
      [styles.delayIn]: this.props.fadeUpDelay,
      [styles.delayOut]: props && !!props.fadeOutTo,
      [styles.fastDelayIn]: style && style.indexOf('fastTransitionIn') > -1,
      [styles.fastDelayOut]: style && style.indexOf('fastTransitionOut') > -1,
      [styles.slowOutFade]: style && style.indexOf('slowOutFade') > -1,
      [styles.slowInFade]: style && style.indexOf('slowInFade') > -1,
      [styles.klimakartDelayIn]: style && style.indexOf('klimakartDelayIn') > -1
    })
    return (
      <div className={wrapperClasses}>
        <Component
          fadeClasses={fadeClasses}
          preload={this.props.preload}
          active={this.props.active}
          style={style}
          {...this.props.section.props}
        />
        {style && style.indexOf('zoomIn') > -1 && <div className={styles.zoomMask} />}
        {photographer && this.props.active && <PhotoCredit style={style} photographer={photographer} type={type} />}
      </div>
    )
  }
}

const connector = connect()
export const Background = connector(_Background)
